/// <reference types="./updateDeleteComponentTypesFromIndexes.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ok } from '@dossierhq/core';
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryRun } from '../QueryFunctions.js';
export async function schemaUpdateDeleteComponentTypesFromIndexes(database, context, componentTypes) {
    if (componentTypes.length > 0) {
        const latestResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql, addValueList }) => {
            sql `DELETE FROM entity_latest_value_types WHERE value_type IN ${addValueList(componentTypes)}`;
        }));
        if (latestResult.isError())
            return latestResult;
        const publishedResult = await queryRun(database, context, buildSqliteSqlQuery(({ sql, addValueList }) => {
            sql `DELETE FROM entity_published_value_types WHERE value_type IN ${addValueList(componentTypes)}`;
        }));
        if (publishedResult.isError())
            return publishedResult;
    }
    return ok(undefined);
}
//# sourceMappingURL=updateDeleteComponentTypesFromIndexes.js.map